export default __webpack_public_path__ + "static/media/four.bd70304d.svg";